import { File } from "react-feather";


export default [
    {
        id:"m-lap-default",
        title:"Manajemen Laporan",
        icon:<File size={20}/>,
        navLink:"/manajemen-laporan/default"
    },
    
]